/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import EnhancedTable from "../../common_components/Tables/EnhancedTable";
import Page from "../../common_components/Page/Page";
import { useDispatch } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import SettingsContext from "../SettingsContext";
import Header from "components/common_components/Header";
import Icon from "components/common_components/Icon";
import Button from "components/common_components/Button";
import Status from "components/common_components/Status";
import { hasElements } from "utils/arrays";

const headCells = [
    { index: 1, id: "name", label: "Name" },
    { index: 2, id: "phoneNumber", label: "Phone Number", sortable: false },
    {
        index: 3,
        id: "isActive",
        label: "Status",
        render: (_, { value, data }) => {
            return <Status id={value ? "active" : "inactive"} />;
        },
    },
    {
        index: 4,
        id: "isAdmin",
        label: "Role",
        sortable: false,
        render: (_, { value, data }) => {
            const isAdmin =
                hasElements(data.groups) &&
                data.groups.reduce((permissions, group) => [...permissions, ...group.permissions], []).map((permission) => permission.id).includes("general.admin");
            return <Status id={isAdmin ? "admin" : "standard"} category={isAdmin ? "info" : "default"} />;
        },
    },
    {
        index: 5,
        id: "isAttorney",
        label: "Attorney",
        sortable: false,
        render: (_, { value, data }) => {
            return <Status id={value ? "attorney" : "non-attorney"} category={value ? "info" : "default"} />;
        },
    },
    {
        index: 6,
        id: "hasRestrictedAccess",
        label: "Access",
        sortable: false,
        render: (_, { value, data }) => {
            return <Status id={value ? "restricted" : "unrestricted"} category={value ? "warning" : "success"} />;
        },
    },
];

function List({ history }) {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pageableData, setPageableData] = useState(undefined);
    const defaultRequestData = {
        filter: {},
        orderBy: "name",
        orderDirection: "asc",
        pageNumber: 0,
        pageSize: 15,
    };

    const { Users } = useContext(SettingsContext);

    function getUsers(requestData = defaultRequestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        Users.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    useEffect(() => {
        getUsers();

        return () => {
            setData([]);
        };
    }, []);

    function onRowClickHandler(item) {
        history.push(`/settings/users/${item.id}`);
    }

    function filterBuilder(filterValue) {
        return filterValue
            ? {
                  name: filterValue,
                  phoneNumber: filterValue,
              }
            : {};
    }

    return (
        <Page>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    <Header title="Users">
                        <Button primary onClick={() => history.push("/settings/users/add")}>
                            <Icon name="add" size="md" color="white" />
                            <span>Add</span>
                        </Button>
                    </Header>
                    <div className="layout">
                        <EnhancedTable
                            headCells={headCells}
                            data={data}
                            defaultOrder={{ order: "asc", orderBy: "name" }}
                            keyColumnName="id"
                            onRowClick={onRowClickHandler}
                            onRequestData={getUsers}
                            filterBuilder={filterBuilder}
                            pageableData={pageableData}
                            defaultRowsPerPage={15}
                        />
                    </div>
                </>
            )}
        </Page>
    );
}

List.propTypes = {
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }),
    }).isRequired,
};

export default withRouter(List);
